function apiHost(): string | null {
  const base = process.env.NEXT_PUBLIC_API_BASE_URL;
  if (!base) return null;

  try {
    return new URL(base).hostname;
  } catch {
    return null;
  }
}

function isTrustedOauthHost(hostname: string): boolean {
  const host = apiHost();
  return host !== null && hostname === host;
}

export function oauthAuthorizeReturnTo(
  returnTo: string | null | undefined,
): string | null {
  if (!returnTo) return null;

  let url: URL;
  try {
    url = new URL(returnTo);
  } catch {
    return null;
  }

  if (url.username || url.password) return null;
  if (url.protocol !== "https:" && url.protocol !== "http:") return null;
  if (url.pathname !== "/oauth/authorize") return null;
  if (!isTrustedOauthHost(url.hostname)) return null;

  return url.toString();
}

export function destinationAfterPasswordLogin(
  returnTo: string | null | undefined,
  fallback: string,
): string {
  const oauthReturn = oauthAuthorizeReturnTo(returnTo);
  if (oauthReturn) {
    return `/two-factor?returnTo=${encodeURIComponent(oauthReturn)}`;
  }
  if (returnTo?.startsWith("/")) return returnTo;
  return fallback;
}

export function destinationAfterFullAuth(
  returnTo: string | null | undefined,
): string {
  const oauthReturn = oauthAuthorizeReturnTo(returnTo);
  if (oauthReturn) return oauthReturn;
  if (returnTo?.startsWith("/")) return returnTo;
  return "/";
}
